export default {
    setUsersList(state, usersList) {
        state.usersList = usersList;
    },
    updateUser(state, user) {
        const item = state.usersList.find((item) => item.uuid === user.uuid);
        Object.assign(item, user);
    },
};
